module.exports = __webpack_public_path__ + "static/pic01-9f1ef24e8d79ed7927393a33a46bdee1.jpg";